'use client'
const INFURA_ID = '87939db78f824920ada5c872db3e56b8';

export { INFURA_ID };
